import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { LoaderAnimation } from 'components';
import { TealiumService } from 'services';
import './loading-screen.scss';

export const LoadingScreen = ({
  loadingMessage = 'Loading',
  secondaryMessage = 'This should only take a moment',
}) => {
  useEffect(() => {
    TealiumService.sendViewToTealium({
      event_name: 'view',
      page_name: 'vodalend compare: loading screen',
    });
  }, []);

  return (
    <div className='loading-screen'>
      <LoaderAnimation height={160} width={120} />
      <h3 className='loading-screen__message'>{loadingMessage}</h3>
      <p className='loading-screen__secondary'>{secondaryMessage}</p>
    </div>
  );
};

LoadingScreen.propTypes = {
  loadingMessage: PropTypes.string,
  secondaryMessage: PropTypes.string,
};
